module.exports = __webpack_public_path__ + "static/media/quem-somos.a370d7ed.jpg";